<template>
  <li>
    <a :href="href" target="_blank" rel="noopener noreferrer" @click="onClickLink">
      <div class="result-item">
        <div class="item-left">
          <div class="img-box">
            <figure>
              <img :src="imageUrl" alt="작가 검색 결과 이미지" loading="lazy"/>
            </figure>
<!--            <HeartButton v-model:isLike="isLike" :uuid="uuid" :likeType="likeType"/>-->
          </div>
        </div>
        <div class="item-right">
          <ul class="dot-list">
            <li
                v-for="(line, idx) in Object.values(highlight).flat()"
                :key="idx"
                v-safe-html="line"
            />
          </ul>
        </div>
      </div>

    </a>
  </li>
</template>

<script setup>
import {defineProps, ref} from 'vue'
import HeartButton from "@/components/ui/HeartButton.vue";

const props = defineProps({
  uuid: {type: String, required: true},
  imageUrl: {type: String, required: true},
  href: {type: String, default: ''},
  likeType: {type: String, default: ''},
  isLike: {type: Boolean, default: false},
  highlight: {type: Object, default: () => ({})}
})

const isLike = ref(props.isLike);

const onClickLink = (e) => {
  if (!props.href) {
    e.preventDefault();
  }
};
</script>

<style scoped>

/* .dot-list 내부의 li에 점을 추가
.result-wrap .result-group .responsive-list .result-item .item-right .dot-list li
{
position: relative;
padding-left: 20px;
line-height: 1.5;
list-style-type: none;
margin-bottom: 10px;
}
*/
/* 점을 li 앞에 배치
  .result-wrap .result-group .responsive-list .result-item .item-right .dot-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  top: -5px;
  color: #999999;
  font-size: 18px;
}
 */
</style>